<div class="dialog-container">
  <div class="dialog-header mt-2">
    <div class="title">Manufacturing Detail Information</div>
    <button type="button" class="btn-close shadow-none" (click)="onClose()" title="Close"></button>
  </div>
  <div class="dialog-content mt-4">
    <div class="filter-container">
      <app-map-view-filter></app-map-view-filter>
    </div>
    <mat-accordion [multi]="true">
      <div class="mt-3">
        <mat-expansion-panel [expanded]="cardPanelOpen">
          <mat-expansion-panel-header>
            <mat-panel-title>KPIs</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="kpi-cards-container mt-3">
            <!-- <div class="kpi-card years-list-card">
              <div>{{ yearRange.startYear }}</div>
              <div>{{ yearRange.endYear }}</div>
            </div> -->
            <div class="kpi-card">
              <div class="kpi-card-header">Revenue</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">
                    <span class="year-data">{{ yearRange.startYear }}</span
                    >{{ kpiCardValues.net_revenue['startYear'] | number : '1.0-0' }}
                  </div>
                  <div class="end-year-value">
                    <span class="year-data">{{ yearRange.endYear }}</span
                    >{{ kpiCardValues.net_revenue['endYear'] | number : '1.0-0' }}
                  </div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.net_revenue['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.net_revenue['percent']"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split">
              <div class="kpi-card-header">Capacity</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.final_capacity['startYear'] | number : '1.0-0' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.final_capacity['endYear'] | number : '1.0-0' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.final_capacity['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.final_capacity['percent']"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split">
              <div class="kpi-card-header">Production</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.production['startYear'] | number : '1.0-0' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.production['endYear'] | number : '1.0-0' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.production['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.production['percent']"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split">
              <div class="kpi-card-header">Avg. Shift</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.avg_shifts['startYear'] | number : '1.0-1' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.avg_shifts['endYear'] | number : '1.0-1' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.avg_shifts['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.avg_shifts['percent']"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split">
              <div class="kpi-card-header">Avg. GE (%)</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.avg_ge['startYear'] | number : '1.0-1' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.avg_ge['endYear'] | number : '1.0-1' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.avg_ge['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.avg_ge['percent']"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split">
              <div class="kpi-card-header">Avg. Waste (%)</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.avg_wastage['startYear'] | number : '1.0-1' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.avg_wastage['endYear'] | number : '1.0-1' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.avg_wastage['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.avg_wastage['percent']" [reverseColor]="true"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split" [ngStyle]="{ 'flex-basis': '220px' }">
              <div class="kpi-card-header">Number of Lines (#)</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.line_count['startYear'] | number : '1.0-0' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.line_count['endYear'] | number : '1.0-0' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.line_count['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.line_count['percent']" [reverseColor]="true"></app-percent-pill>
              </div>
            </div>
            <div class="kpi-card card-split">
              <div class="kpi-card-header">Headcounts (#)</div>
              <div class="kpi-card-body">
                <div class="card-content">
                  <div class="start-year-value">{{ kpiCardValues.headcount['startYear'] | number : '1.0-0' }}</div>
                  <div class="end-year-value">{{ kpiCardValues.headcount['endYear'] | number : '1.0-0' }}</div>
                </div>
                <!-- <div class="percent-content">
                                    <img src="../../../assets/images/arrow_upward_alt.svg" />
                                    <div class="percentage-value">{{kpiCardValues.headcount['percent'] | number : '1.0-0'}}%</div>
                                </div> -->
                <app-percent-pill [ngStyle]="{ 'align-self': 'center' }" [percent]="kpiCardValues.headcount['percent']"></app-percent-pill>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
      <div class="mt-3">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Details</mat-panel-title>
          </mat-expansion-panel-header>
          <app-map-view-expandable-table [header]="tableHeader" [tableData]="tableData"></app-map-view-expandable-table>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
</div>
